import { render, staticRenderFns } from "./planetHome.vue?vue&type=template&id=2501a98e&scoped=true"
import script from "./planetHome.vue?vue&type=script&lang=js"
export * from "./planetHome.vue?vue&type=script&lang=js"
import style0 from "./planetHome.vue?vue&type=style&index=0&id=2501a98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501a98e",
  null
  
)

export default component.exports